import cloneDeep from 'lodash/cloneDeep';

export const SOURCE_KINDS = Object.freeze({
    PAGE: 'page',
    FEATURE: 'feature',
    TRACK_TYPE: 'trackType',
    APPS: 'apps',
    PRODUCT_AREAS: 'productAreas',
    VISITORS: 'visitors',
    ACCOUNTS: 'accounts',
    WEB_ANALYTICS: 'webAnalytics',
});

const ENTITY_SOURCE_KINDS = new Set([SOURCE_KINDS.PAGE, SOURCE_KINDS.FEATURE, SOURCE_KINDS.TRACK_TYPE]);

export const isEntitySourceKind = (kind) => ENTITY_SOURCE_KINDS.has(kind);

export function isValidSource (source) {
    if (!source || typeof source !== 'object') return false;
    if (!Object.values(SOURCE_KINDS).includes(source.kind)) return false;
    if (isEntitySourceKind(source.kind)) return !!source.id;

    return true;
}

/**
 * FROZEN CONTRACT (APP-165060): widget definitions persist unversioned, so shapes produced
 * here must stay readable forever. `definition.source` is a structured { kind, id? } descriptor
 * (see SOURCE_KINDS), never a raw href. Shared page-state fields use fixed names: appId (array),
 * segmentId, dateRange, filters, columns, compare, search.
 * Deep-clones `definition`; throws on bad input — guard before calling from computeds.
 */
export function buildWidget ({ type, name, definition = {}, source }) {
    if (!type) {
        throw new Error('buildWidget requires a widget type');
    }
    if (source && !isValidSource(source)) {
        throw new Error(`buildWidget received an invalid source descriptor: ${JSON.stringify(source)}`);
    }

    const builtDefinition = cloneDeep(definition);
    Object.keys(builtDefinition).forEach((key) => {
        if (builtDefinition[key] === undefined) delete builtDefinition[key];
    });
    if (source) {
        builtDefinition.source = source.id ? { kind: source.kind, id: source.id } : { kind: source.kind };
    }

    return { type, name, definition: builtDefinition };
}
